export const types = {
  SET_CONTEXT_DATA: 'SET_CONTEXT_DATA',
};

export const initialState = {
  data: null,
};

const ContextReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CONTEXT_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  setContextData: (data) => ({
    type: types.SET_CONTEXT_DATA,
    payload: data,
  }),
};

export default ContextReducer;
